import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'ptl-toast',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ptl-toast.component.html',
  styleUrls: ['./ptl-toast.component.scss'],
})
export class PtlToastComponent {
  message = input('');
  type = input<'success' | 'error' | 'info'>('success');
  closed = output<void>();

  protected readonly iconConfig = computed(() => {
    const map: Record<string, { icon: string; color: string }> = {
      success: { icon: '\u2713', color: 'var(--lime)' },
      error: { icon: '\u2715', color: 'var(--coral)' },
      info: { icon: '\u2139', color: 'var(--accentBdr)' },
    };
    return map[this.type()] ?? map['success'];
  });
}
